import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { useSelector } from "react-redux";
import { db } from "../../firebase";
import { useCallback } from "react";
import { landmine } from "../../util/gameDefault";
import toast from "react-hot-toast";

function generateRandomNumbers(range, count) {
  const randomNumbers = new Set();
  while (randomNumbers.size < count) {
    const randomNum = Math.ceil(Math.random() * range);
    randomNumbers.add(randomNum);
  }

  return Array.from(randomNumbers);
}

const LandmineHooks = () => {
  const {
    landmine: { landmineUsers, boardSize, mineCount },
    roomId,
  } = useSelector(state => state.GameSlice);
  const { userId, nickname } = useSelector(state => state.LoginInfoSlice);

  const JoinLandmine = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);

    updateDoc(docRef, {
      "landmine.landmineUsers": arrayUnion({
        userId,
        nickname,
        end: false,
        rank: 0,
      }),
    });
    // updateDoc(docRef, {
    //   "landmine.landmineUsers": arrayUnion({
    //     userId: "test",
    //     nickname: "test",
    //     end: false,
    //     rank: 0,
    //   }),
    // });
  }, [roomId, userId, nickname]);

  const ExitLandmine = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);

    const remainUsers = landmineUsers.filter(i => i?.userId !== userId);

    updateDoc(docRef, {
      "landmine.landmineUsers": remainUsers,
    });
  }, [roomId, landmineUsers, userId]);

  const ResetGame = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    updateDoc(docRef, {
      landmine,
    });
  }, [roomId]);

  const StartLandmine = useCallback(() => {
    if (landmineUsers.length > 1) {
      const docRef = doc(db, "game", `room${roomId}`);
      const turnUser = landmineUsers[0];
      const boardRange = boardSize * boardSize + 1;
      const mineLocation = generateRandomNumbers(boardRange, mineCount);
      const landmineBoard = {};
      for (let i = 1; i < boardRange + 1; i++) {
        const row = Math.ceil(i / boardSize);
        const column = i % boardSize || 10;
        const location = `${row}x${column}`;
        const checkMine = mineLocation.includes(i);
        const item = {
          reveal: false,
          mine: checkMine,
          userId: "",
          nickname: "",
        };
        landmineBoard[location] = item;
      }

      updateDoc(docRef, {
        "landmine.landmineBoard": landmineBoard,
        "landmine.turnUser": turnUser,
        "landmine.gameStatus": true,
      });
    } else {
      toast.error("인원이 모자랍니다.");
    }
  }, [boardSize, mineCount, landmineUsers, roomId]);
  const SizeHandler = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    const value = boardSize > 10 ? 10 : 30;
    updateDoc(docRef, {
      "landmine.boardSize": value,
    });
  }, [boardSize, roomId]);

  const MineHandler = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    const mines = [1, 5, 10];
    const value = mines[mines.findIndex(i => i === mineCount) + 1] || 1;
    updateDoc(docRef, {
      "landmine.mineCount": value,
    });
  }, [mineCount, roomId]);

  return {
    JoinLandmine,
    ExitLandmine,
    ResetGame,
    StartLandmine,
    SizeHandler,
    MineHandler,
  };
};

export default LandmineHooks;
